import { styled, css } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';

const PAGE_MAX_WIDTH = '1200px';
const STYLED_FLEX_WIDTH_DESKTOP = '390px';
const STYLED_FLEX_WIDTH_MOBILE = '520px';

export const StyledSection = styled(Box)<{ isControlVersion: boolean }>`
  ${props =>
    props.isControlVersion
      ? css`
          padding: ${themeSpace(10)} ${themeSpace(4)} ${themeSpace(0)};
          margin-top: ${themeSpace(5)};
        `
      : css`
          padding: ${themeSpace(10)} ${themeSpace(7)} ${themeSpace(8)};

          ${themeMediaQuery('md')} {
            padding: ${themeSpace(10)} ${themeSpace(12)} ${themeSpace(8)};
          }
          ${themeMediaQuery('lg')} {
            max-width: ${PAGE_MAX_WIDTH};
            padding: ${themeSpace(10)} 0 ${themeSpace(8)};
          }
        `}
`;

export const StyledFlex = styled(Flex)<{ isControlVersion: boolean }>`
  ${props =>
    props.isControlVersion &&
    css`
      max-width: ${STYLED_FLEX_WIDTH_DESKTOP};
      ${themeMediaQuery('sm')} {
        max-width: ${STYLED_FLEX_WIDTH_MOBILE};
      }
    `}
`;

export const StyledTextPairing = styled(TextPairing)<{ isControlVersion: boolean }>`
  .text-pairing-title {
    margin-bottom: ${themeSpace(5)};
  }
  ${props =>
    props.isControlVersion &&
    css`
      .text-pairing-title {
        font-size: 56px;
        line-height: 68px;
        margin-bottom: ${themeSpace(5)};
      }
      ${themeMediaQuery('below_sm')} {
        .text-pairing-title {
          ${themeVariant('hed40')};
        }
        .text-pairing-body {
          ${themeVariant('featureCopy17')};
        }
      }
    `}
`;

export const StyledGridContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  grid-gap: ${themeSpace(6)};
  ${themeMediaQuery('md')} {
    display: grid;
    grid-template-columns: 3fr 2fr;
  }
`;

export const StyledCardWrapper = styled(Box)`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-gap: ${themeSpace(6)};
`;
